import axios from 'axios';
import qs from 'qs';
import { HTTP_STATUS } from '@/shared/config/httpStatus';
import { getAuthToken, removeAuthToken } from '@/shared/lib/auth';

// 환경에 따른 API URL 설정
const API_BASE_URL = import.meta.env.VITE_BASE_URL + '/api';
export const API_BASE_LOGIN_URL = import.meta.env.VITE_BASE_URL;

// axios 인스턴스 생성
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },

  // paramsSerializer 추가
  paramsSerializer: (params) => {
    return qs.stringify(params, {
      arrayFormat: 'repeat', // 배열을 ?key=value1&key=value2 형태로
      skipNulls: true, // null/undefined 값 제외
      encode: true,
    });
  },
});

// 요청 인터셉터 설정
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// 응답 인터셉터 설정
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 오류 처리 (인증 만료)
    if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
      removeAuthToken();
      window.location.href = '/sign-in';
    }
    return Promise.reject(error);
  },
);

export default apiClient;
